import { Component, input, ChangeDetectionStrategy, ViewEncapsulation, computed } from "@angular/core";
import { CommonModule } from "@angular/common";
import { cn } from "../utils/utils";

@Component({
  selector: "agent-chat-message-view-cursor",
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `<div [class]="computedClass()"></div>`,
})
export class AgentChatMessageViewCursor {
  inputClass = input<string | undefined>();

  computedClass = computed(() => cn("achat-cursor", this.inputClass()));
}
